import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material';
import { DatatableComponent } from '@swimlane/ngx-datatable';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';

import { AppLoaderService } from '../../../../shared/services/app-loader/app-loader.service';
import { CommonService } from 'app/shared/services/MyServices/common.service';
import { Page } from '../../../../../../src/app/shared/models/PaginationPage';

import { InventoryService } from 'app/shared/services/MyServices/inventory.service';
@Component({
  selector: "app-mis-report",
  templateUrl: "./mis-report.component.html",
  styleUrls: ["./mis-report.component.scss"],
})
export class MisReportComponent implements OnInit {
  page = new Page();
  items: any[] = [];
  leaditems: any[] = [];
  temp = [];
  tableOffset: any;

  SessionData: any;
  RoleType: any;
  isDealer: boolean = true;
  isPageUrlCheck: any;

  tab1: boolean = true;
  tab2: boolean = false;
  Subtab1: boolean = true;
  Subtab2: boolean = false;
  Subtab3: boolean = false;
  SubtabCat1: boolean = true;
  SubtabCat2: boolean = false;
  SubtabCat3: boolean = false;
  filterValue: any = {};
    isReset:boolean = false;
  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;

  constructor(
    private loader: AppLoaderService,
    private commonservice: CommonService,
    private datepipe: DatePipe
  ) {
    this.page.pageNumber = 0;
    this.page.size = 9;
    this.page.totalElements = 0;
    this.page.totalElementsPark = 0;
  }

  ngOnInit() {
    this.tableOffset = 0;
    this.SessionData = this.commonservice.getUserDetails();
    this.RoleType = this.SessionData.role_name;

    if (this.RoleType === "Seller") {
      this.RoleType = "Dealer";
    } else {
      this.RoleType = "Admin";
    }

    this.isDealer = this.RoleType !== "Dealer";

    this.switchTab(1);
  }

  switchTab(tabNumber: number) {
    this.page.pageNumber = 0;
    this.tableOffset = 0;

    if (tabNumber === 1) {
      this.tab1 = true;
      this.tab2 = false;
      this.SubtabCat1 = true;
      this.SubtabCat2 = false;
      this.SubtabCat3 = false;
      this.switchSubTabCatalouge(1);
    } else if (tabNumber === 2) {
      this.tab1 = false;
      this.tab2 = true;
      this.Subtab1 = true;
      this.Subtab2 = false;
      this.Subtab3 = false;
      this.switchSubTab(1);
    }
  }

  switchSubTabCatalouge(tabNumber: number) {
    this.page.pageNumber = 0;
    this.tableOffset = 0;
    this.filterValue = {};
    this.isReset = false;
  setTimeout(() => {
    this.isReset = true;
  });
    if (tabNumber === 1) {
      this.SubtabCat1 = true;
      this.SubtabCat2 = false;
      this.SubtabCat3 = false;
    } else if (tabNumber === 2) {
      this.SubtabCat1 = false;
      this.SubtabCat2 = true;
      this.SubtabCat3 = false;
    } else {
      this.SubtabCat1 = false;
      this.SubtabCat2 = false;
      this.SubtabCat3 = true;
    }
    this.getData();
  }

  switchSubTab(tabNumber: number) {
    this.page.pageNumber = 0;
    this.tableOffset = 0;
    this.filterValue = {};
    this.isReset = false;
  setTimeout(() => {
    this.isReset = true;
  });
    if (tabNumber === 1) {
      this.Subtab1 = true;
      this.Subtab2 = false;
      this.Subtab3 = false;
    } else if (tabNumber === 2) {
      this.Subtab1 = false;
      this.Subtab2 = true;
      this.Subtab3 = false;
    } else {
      this.Subtab1 = false;
      this.Subtab2 = false;
      this.Subtab3 = true;
    }
    this.getParkList();
  }

  getData() {
    const ListInput: ListInput = {} as ListInput;
    ListInput.offset = 0;
    this.getInventoryList(ListInput);
  }

  getInventoryList(ListInput: ListInput) {
    let params_approval_status: any = "";

    if (this.SubtabCat1) {
      params_approval_status = "APPROVED";
    } else if (this.SubtabCat2) {
      params_approval_status = ["QC_APPROVED", "INITIATED"];
    } else if (this.SubtabCat3) {
      params_approval_status = "";
    }
    this.loader.open();
    let request = {
      user_id: null,
      cat_id: "2",
      offset: ListInput.offset,
      text_search: "",
      expired: this.SubtabCat3 ? true : false,
      visibility: "",
      lob: "",
      ppl: "",
      brand: "",
      is_active: "",
      osp_is_active: true,
      params_approval_status: params_approval_status,
      vc_number: ListInput.vc_number ? ListInput.vc_number : "",
      created_from_date: ListInput.created_from_date ? ListInput.created_from_date : "",
      created_to_date: ListInput.created_to_date ? ListInput.created_to_date : "",
    };

    this.commonservice.MISList(request).subscribe(
      (res) => {
         if (res instanceof HttpErrorResponse) {
          this.loader.close();
          Swal.fire('Error fetching data', 'Error');
          return;
        }
        if (res.success) {
          this.page.totalElementsPark = res.total_count;
          this.items = this.temp = res.data;
          this.loader.close();
        } else {
          Swal.fire(res.data.msg);
          this.items = [];
          this.page.totalElementsPark = 0;
          this.items = this.temp = [];
          this.loader.close();
        }
      },
      (err) => {
        this.loader.close();
        console.error("Error occurred", err);
      }
    );
  }

  getParkList() {
    const ListInput: ListInput = {} as ListInput;
    ListInput.offset = 0;
    this.getparkDataList(ListInput);
  }

  getparkDataList(ListInput: ListInput) {
    let params_approval_status: any = "";

    if (this.Subtab1) {
      params_approval_status = "APPROVED";
    } else if (this.Subtab2) {
      params_approval_status = ["QC_APPROVED", "INITIATED"];
    } else if (this.Subtab3) {
      params_approval_status = "";
    }
    let request = {
      user_id: null,
      cat_id: "3",
      offset: ListInput.offset,
      text_search: "",
      expired: this.Subtab3 ? true : false,
      visibility: "",
      lob: "",
      ppl: "",
      brand: "",
      is_active: "",
      osp_is_active: true,
      params_approval_status: params_approval_status,
      vc_number: ListInput.vc_number ? ListInput.vc_number : "",
      created_from_date: ListInput.created_from_date ? ListInput.created_from_date : "",
      created_to_date: ListInput.created_to_date ? ListInput.created_to_date : "",
    };
    this.loader.open();
    this.commonservice.MISList(request).subscribe(
      (data) => {
        if (data instanceof HttpErrorResponse) {
          this.loader.close();
          Swal.fire('Error fetching data', 'Error');
          return;
        }
        if (data.success) {
          this.loader.close();
          this.page.totalElements = data.total_count;
          this.leaditems = this.temp = data.data;
        } else {
          this.leaditems = [];
          Swal.fire(data.data.msg, "Error");
          this.page.totalElements = 0;
          this.leaditems = this.temp = [];
          this.loader.close();
        }
      },
      (err) => {
        this.page.totalElements = 0;
        this.leaditems = [];
        this.loader.close();
      }
    );
  }

  setPage(pageInfo: any) {
    this.tableOffset = pageInfo.offset;
    this.page.pageNumber = pageInfo.offset;

    const ListInput: ListInput = {} as ListInput;
    ListInput.offset = pageInfo.offset * 10;
    this.table.offset = 0;

    if (this.tab2) {
      this.getparkDataList(ListInput);
    } else {
      this.getInventoryList(ListInput);
    }
  }

  downloadAllLeadDataAndExcelParkNSELL(): void {
    this.loader.open();
    let offset = 0;
    const pageSize = 10;
  
    const allLeadItems: any[] = [];

    const fetchData = (currentOffset: number) => {
      let params_approval_status: any = "";

      if (this.Subtab1) {
        params_approval_status = "APPROVED";
      } else if (this.Subtab2) {
        params_approval_status = ["QC_APPROVED", "INITIATED"];
      } else if (this.Subtab3) {
        params_approval_status = "";
      }
      let request = {
        user_id: null,
        cat_id: "3",
        offset: currentOffset,
        text_search: "",
        expired:this.Subtab3 ? true : false,
        visibility: "",
        lob: "",
        ppl: "",
        brand: "",
        is_active: "",
        osp_is_active: true,
        params_approval_status: params_approval_status,
        vc_number: this.filterValue.vc_number ? this.filterValue.vc_number : "",
      created_from_date: this.filterValue.fromDate ? this.filterValue.fromDate : "",
      created_to_date: this.filterValue.toDate ? this.filterValue.toDate : "",
      };

      this.commonservice.MISList(request).subscribe(
        (data) => {
          if (data instanceof HttpErrorResponse) {
            this.loader.close();
            Swal.fire("Error fetching data", "Error");
            return;
          }

          if (data.success) {
            allLeadItems.push(...data.data);
            const totalFetched = allLeadItems.length;
            const totalAvailable = data.total_count;

            if (totalFetched >= totalAvailable) {
              this.downloadExcel(allLeadItems);
              this.loader.close();
              return;
            }

            fetchData(currentOffset + 1);
          } else {
            this.loader.close();
            Swal.fire(data.data.msg, "Error");
          }
        },
        (err) => {
          this.loader.close();
          Swal.fire("Error fetching data", "Error");
        }
      );
    };

    fetchData(offset);
  }

  private downloadExcel(leadItems: any[]): void {
    const modifiedLeadItems = leadItems.map((item) => {
      const baseData: any = {
  "Inventory ID": item.inventory_code,
  "Registration No": item.veh_registration_number,
  "Certificate Type": item.vehicle_certificate_type,
  "Finance Availability": item.finance_availability,
  "Warranty": item.engine_warranty,
  "Days Left": this.getDaysLeft(item),
  "Price": item.dealer_suggestive_price,
  "Approval Status": this.getFormattedApprovalStatus(item.params_approval_status),
  "Emission": item.emission,
  "Kms": item.odometer,
  "Manufacture Year": item.year_of_manufacture,
  "Dealer Name": item.user.organization_name,
  "Contact Number": item.user.mobile_no
      };
 if (this.Subtab3) {
        baseData["SOLD From"] = item.sold_from;
      }

      return baseData;
    });

    const worksheet: XLSX.WorkSheet =
      XLSX.utils.json_to_sheet(modifiedLeadItems);
    const columnCount = Object.keys(modifiedLeadItems[0]).length;
    const columnWidths = Array(columnCount).fill({ wch: 30 });

    worksheet["!cols"] = columnWidths;

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
const namedata = this.Subtab1
  ? "Active_Vehicle_List"
  : this.Subtab2
  ? "Ready_for_Active_Vehicle_List"
  : "Inactive_Vehicle_List";

    this.saveAsExcelFile(excelBuffer, "PARK-SELL_" + namedata);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    saveAs(data, fileName + "_" + new Date().getTime() + ".xlsx");
  }

  downloadAllLeadDataAndExcelCatalouge(): void {
    this.loader.open();
    let offset = 0;
    const pageSize = 10;
    const allLeadItems: any[] = [];

    const fetchData = (currentOffset: number) => {
      let params_approval_status: any = "";

      if (this.SubtabCat1) {
        params_approval_status = "APPROVED";
      } else if (this.SubtabCat2) {
        params_approval_status = ["QC_APPROVED", "INITIATED"];
      } else if (this.SubtabCat3) {
        params_approval_status = "";
      }

      let request = {
        user_id: null,
        cat_id: "2",
        offset: currentOffset,
        text_search: "",
        expired: this.SubtabCat3 ? true : false,
        visibility: "",
        lob: "",
        ppl: "",
        brand: "",
        is_active: "",
        osp_is_active: true,
        params_approval_status: params_approval_status,
        vc_number: this.filterValue.vc_number ? this.filterValue.vc_number : "",
      created_from_date: this.filterValue.fromDate ? this.filterValue.fromDate : "",
      created_to_date: this.filterValue.toDate ? this.filterValue.toDate : "",
      };

      this.commonservice.MISList(request).subscribe(
        (data) => {
          if (data instanceof HttpErrorResponse) {
            this.loader.close();
            Swal.fire("Error fetching data", "Error");
            return;
          }

          if (data.success) {
            allLeadItems.push(...data.data);
            const totalFetched = allLeadItems.length;
            const totalAvailable = data.total_count;

            if (totalFetched >= totalAvailable) {
              this.downloadExcelCatalogue(allLeadItems);
              this.loader.close();
              return;
            }

            fetchData(currentOffset + 1*10);
          } else {
            this.loader.close();
            Swal.fire(data.data.msg, "Error");
          }
        },
        (err) => {
          this.loader.close();
          Swal.fire("Error fetching data", "Error");
        }
      );
    };

    fetchData(offset);
  }

  private downloadExcelCatalogue(leadItems: any[]): void {
    const modifiedLeadItems = leadItems.map((item) => {
      const baseData: any = {
        "Inventory Type": item.cat.cat_name,
        "Registration No": item.veh_registration_number,
        Category: item.sub_cat.sub_cat_name,
        "Dealer Suggestive Price": item.dealer_suggestive_price,
        "Approval Status": this.getFormattedApprovalStatus(
          item.params_approval_status
        ),
        "Chassis No": item.chassis_no,
        "No Of Owner": item.no_of_owners,
        "Fuel Type": item.fuel_type,
        "Dealer Code": item.user.distributor_code,
        "Inventory Date": this.datepipe.transform(
          item.Inv_date,
          "dd-MM-yyyy hh:mm:ss a"
        ),
        Brand: item.brand,
      };
      if (this.SubtabCat3) {
        baseData["SOLD From"] = item.sold_from;
      }
      return baseData;
    });

    const worksheet: XLSX.WorkSheet =
      XLSX.utils.json_to_sheet(modifiedLeadItems);
    const columnCount = Object.keys(modifiedLeadItems[0]).length;
    const columnWidths = Array(columnCount).fill({ wch: 30 });

    worksheet["!cols"] = columnWidths;

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const namedata = this.SubtabCat1
  ? "Active_Vehicle_List"
  : this.SubtabCat2
  ? "Ready_for_Active_Vehicle_List"
  : "Inactive_Vehicle_List";

    this.saveAsExcelFileCatalogue(excelBuffer, "Catalogue_ " + namedata);
  }

  private saveAsExcelFileCatalogue(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    saveAs(data, fileName + "_" + new Date().getTime() + ".xlsx");
  }

  getFormattedApprovalStatus(status: string): string {
    return status ? status.replace(/_/g, " ") : "";
  }
  getDaysLeft(rowData: any): number {
    let date1 = this.datepipe.transform(rowData.extend_date_at, "yyyy/MM/dd");
    const fromDate = new Date(date1);
    const toDate = new Date();
    const thirtyDaysLater = new Date(fromDate);
    // let daysInMonth = this.GFG_Fun();
    let daysInMonth = 30;
    thirtyDaysLater.setDate(thirtyDaysLater.getDate() + daysInMonth);

    // Get the time difference in milliseconds
    if (fromDate) {
      if (!rowData.extend) {
        const timeDifference = toDate.getTime() - fromDate.getTime();
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

        return 45 - daysDifference;
      } else {
        const timeDifference = fromDate.getTime() - toDate.getTime();
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
        return daysDifference;
      }
    }

    // Convert milliseconds to days
  }

  handleFilters(filters) {
    this.filterValue = {};
    this.filterValue = filters;
    this.tableOffset = 0;

    const ResponseData: ListInput = {} as ListInput;

    ResponseData.offset = 0 ;
    ResponseData.created_from_date = filters.fromDate || "";
    ResponseData.created_to_date = filters.toDate || "";
    ResponseData.vc_number = filters.vc_number || "";

    if (filters == "reset") {
      this.tableOffset = 0;
      this.filterValue = {};
      this.refreshListing();
    } else {
      const ListInput: ListInput = {} as ListInput;
      ListInput.offset = 0;
      this.table.offset = 0;

      if (this.tab2) {
       
        this.getparkDataList(ResponseData);
      } else {
        this.getInventoryList(ResponseData);
      }
    }
  }
  refreshListing() {
    this.filterValue = {};
    this.isReset = true;
    setTimeout(() => {
      this.isReset = false;
    }, 300);
    const ResponseData: ListInput = {} as ListInput;

    ResponseData.offset = 0 ;
    ResponseData.created_from_date = "";
    ResponseData.created_to_date = "";
    ResponseData.vc_number = "";
    if (this.tab2) {
       
        this.getparkDataList(ResponseData);
      } else {
        this.getInventoryList(ResponseData);
      }
  }
   getiscover(data:any){
    const original_data = data
    const images = [...data];
    const filteredImages = images.filter(item => item.is_cover === true);

    if (filteredImages.length > 0) {
        return filteredImages[0].path
    } else {
        return original_data[0].path
    }
  }
}

export class ListInput {
  offset: number;
  size: number;
  lead_source: string;
  cat_id: any;
  lead_stage: string;
    mobile_number: string;
  limit: number;
  user_id: any;
  text_search: string;
  visibility: string;
  state: string;
  max_odometer: number;
  min_odometer: number;
  city: string;
  district: string;
  minimum_budget: number;
  no_of_owners: string;
  region: string;
  expired: any;
  vehicle_category: string;
  vehicle_type: string;
  finance_availability: string;
  engine_warranty: string;
  emission: string;
  sub_cat_name:string;
  sub_cat_detail_name:string;
  lob:string;
  ppl:string;
  is_active:any;
  osp_is_active:any;
  params_approval_status:any
  from_date:any;
  to_date:any;
  registration_number:any;
  vc_number:any;
  created_from_date:any;
  created_to_date:any;
}